export default class SingleProductFn {
  constructor () {
    this.createInteractions()
  }

  selectorMinus = () => {
    const currentQuantity = Number(document.getElementById('productQuantity').value) || 1

    if (currentQuantity > 1) {
      this.setQuantity(currentQuantity - 1)
    }
  }

  selectorPlus = () => {
    const currentQuantity = Number(document.getElementById('productQuantity').value) || 0
    this.setQuantity(currentQuantity + 1)
  }

  setQuantity (number) {
    const productPrice = Number(document.getElementsByClassName('product_display_price')[0].innerHTML.replace('€', '')) / document.getElementsByClassName('selector_number')[0].innerHTML
    const displayPrice = productPrice * number
    document.getElementsByClassName('product_display_price')[0].innerHTML = displayPrice + '€'

    document.getElementById('productQuantity').setAttribute('value', number)
    document.getElementsByClassName('selector_number')[0].innerHTML = number
  }

  variationAction = (variation) => {
    const target = variation.target
    if (!target.attributes.price && !target.attributes.cart_url) return
    document.getElementsByClassName('active')[0].classList.remove('active')
    target.classList.add('active')
    const displayPrice = target.attributes.price.value * document.getElementById('productQuantity').value
    document.getElementsByClassName('product_display_price')[0].innerHTML = displayPrice + '€'
    document.getElementById('form_add_cart').action = target.attributes.cart_url.value
  }

  openCart() {
    document.getElementsByClassName('mini_cart')[0].classList.add('visible')
  }

  createInteractions = () => {
    document.getElementById('selector_minus').addEventListener('click', this.selectorMinus)
    document.getElementById('selector_plus').addEventListener('click', this.selectorPlus)
    const variations = document.getElementsByClassName('each_variation')
    if (variations.length > 0) {
      for (let i = 0; i < variations.length; i++) {
        variations[i].addEventListener('click', this.variationAction)
      }
    }

    var el = document.getElementById("addedToCart");
    if(el){
      document.getElementById('addedToCart').addEventListener('click', this.openCart)
    }
  }
}
